import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#000" fill="#474747"><path d="M10 13a2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2 2 2 0 012 2z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} overflow="visible" opacity={0.32} /><path d="M8 2C5.186 2 2.828 3 1 4.586V6h1.48C4 4.736 5.7 4 8 4c2.3 0 4 .78 5.52 2H15V4.62C13.36 3.153 10.814 2 8 2z" style={{
        marker: "none"
      }} overflow="visible" opacity={0.32} /><path d="M8 5c-1.504 0-2.86.36-3.875 1h7.688C10.791 5.373 9.462 5 8 5z" style={{
        marker: "none"
      }} overflow="visible" opacity={0.32} /><path d="M3.496 6.996h.016c.829 0 1.496.667 1.496 1.496v.016c0 .829-.667 1.496-1.496 1.496h-.016A1.493 1.493 0 012 8.508v-.016c0-.829.667-1.496 1.496-1.496zm4 0h.016c.829 0 1.496.667 1.496 1.496v.016c0 .829-.667 1.496-1.496 1.496h-.016A1.493 1.493 0 016 8.508v-.016c0-.829.667-1.496 1.496-1.496zm4.008 0c.833 0 1.504.667 1.504 1.496v.016c0 .829-.67 1.496-1.504 1.496A1.497 1.497 0 0110 8.508v-.016c0-.829.67-1.496 1.504-1.496z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} display="block" overflow="visible" /></g></svg>;
}

export default SvgComponent;